import React from 'react';
import PropTypes from 'prop-types';

import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { getResourceTo } from 'react/utils/utils';
import { TextField, ColorPickerField } from 'react/components/fields';

function GeneralInformation({ idpName, themeColor }) {
  return (
    <FormSection
      title="samlConfiguration.sidebar.generalInformation"
      subtitle="samlConfiguration.generalInfoSection.subtitle"
    >
      <FormSectionColumn>
        <TextField
          description="idpName"
          label="samlConfiguration.idpName"
          name="idp.idpName"
          required
        />
        <ColorPickerField
          name="idp.idpThemeColor"
          description="idpThemeColor"
          label="samlConfiguration.idpThemeColor"
          value={themeColor || '#1469BA'}
        />
      </FormSectionColumn>
      <FormSectionColumn>
        <div className="loginBoxWrapper">
          <p className="title">
            {`${getResourceTo('samlConfiguration,loginBox.title')}`}
          </p>
          <div id="LoginBox">
            <img
              className="login-greenmile-logo"
              alt="brand"
              src="static/images/brand.svg"
              width="204"
              height="38"
              role="presentation"
            />
            <div className="loginForm">
              <span className="loginDescription">
                {`${getResourceTo('login.label.description')} GreenMile Live`}
              </span>
              <span
                className="loginVersion"
                title={`${App.Version.displayInfo}`}
              >
                {App.Version.GMLVersionName}
              </span>
              <span className="loginVersion" />
              <div className="loginInput login-username-input">
                <input
                  placeholder="Username"
                  id="j_username"
                  type="type"
                  tabIndex="0"
                />
              </div>
              <div>
                <div className="loginInput login-password-input">
                  <input
                    id="j_password"
                    type="password"
                    placeholder="Password"
                    tabIndex="0"
                  />
                  <i role="button" tabIndex="0" aria-label="Toggle password" />
                </div>
              </div>
              <a className="forgotPassword">
                {getResourceTo('login.forgotpassword')}
              </a>
              <button type="button">LOGIN</button>
            </div>
            {idpName && (
              <>
                <div className="separator">or</div>
                <div className="providerIdentitiesContainer">
                  <button
                    type="button"
                    style={{
                      display: 'block',
                      background: `${themeColor} 0% 0% no-repeat padding-box`,
                      color: 'white'
                    }}
                  >
                    {`${getResourceTo('button.login')} ${idpName}`}
                  </button>
                </div>
              </>
            )}
          </div>
          <p className="loginBoxLabel">
            {`${getResourceTo(
              'samlConfiguration.generalInfoSection.subtitle'
            )}`}
          </p>
        </div>
      </FormSectionColumn>
    </FormSection>
  );
}

GeneralInformation.propTypes = {
  idpName: PropTypes.string,
  themeColor: PropTypes.string
};

GeneralInformation.defaultProps = {
  idpName: '',
  themeColor: '#1469BA'
};

export default GeneralInformation;
